/**
 * 停机维护状态。
 *
 * 由服务器上的静态文件 /maintenance-config.json 控制：运维把该文件的 enabled
 * 改为 true 即全站展示停机升级公告，改为 false 恢复，改完保存即可生效，无需重新发版。
 */

const DEFAULT_STATE = {
  enabled: false,
  title: '系统停机升级公告',
  startTime: '',
  endTime: '',
  content:
    '为了提供更稳定、更优质的服务，我们将对系统进行停机升级维护。升级期间，会员注册登录、权益查询、售后申请、扫码核销等功能将暂停使用，请您合理安排使用时间，由此带来的不便，我们深表歉意。',
}

const state = { ...DEFAULT_STATE }

export function getMaintenanceState() {
  return state
}

// 启动前读取维护配置；cache: 'no-store' 保证每次拿到服务器上的最新开关
export function loadMaintenanceConfig() {
  if (typeof fetch !== 'function') {
    return Promise.resolve(state)
  }
  return fetch('/maintenance-config.json', { cache: 'no-store' })
    .then(res => res.json())
    .then(data => {
      if (data && typeof data === 'object') {
        Object.keys(data).forEach(key => {
          if (!key.startsWith('_')) {
            state[key] = data[key]
          }
        })
        state.enabled = data.enabled === true
      }
      return state
    })
    .catch(() => state)
}
